import { render, staticRenderFns } from "./TaskUpdateStartDate.vue?vue&type=template&id=80382940&scoped=true"
import script from "./TaskUpdateStartDate.vue?vue&type=script&lang=js"
export * from "./TaskUpdateStartDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80382940",
  null
  
)

export default component.exports